<template>
  <DashboardTemplate :navMenu="true" class="custom-activity">
    <div class="text-left pd-b-3 disabled-on-print">
      <h2 class="mg-less">จัดการหลักสูตร</h2>
    </div>
    <div v-if="courseList.length > 0">
      <div class="pd-b-3 flex-display js-between change-display disabled-on-print">
        <div class="text-left flex-display ai-center change-display">
          <p class="mg-less">เลือกหลักสูตร</p>
          <el-dropdown class="mg-l-4" trigger="click">
            <span class="el-dropdown-link course-box">
              <span class="message-over clamp1">{{
                getCourseLabel(course)
              }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="course-box-menu">
              <el-dropdown-item v-for="item in courseList" :key="item._id">
                <div
                  :title="item.name"
                  @click="course = item._id"
                  class="width-100 dropdown-text-over"
                >
                  {{ item.name }}
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            @click="selectCourse"
            type="primary"
            class="light mg-l-4 btn-show"
            round
            >แสดงผล</el-button
          >
        </div>
      </div>

      <el-tabs v-model="activeName" class="secondary">
        <el-tab-pane label="กระดานถาม - ตอบระหว่างเรียน (Discussion Forum)" name="1">
          <div v-loading="loading" class="pd-b-3">
            <ActivityTotalScoreListInstructor
              :dataList="subjectList"
              :courseId="courseId"
              shwoColumn="discussionForum"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane  label="งานที่ได้รับมอบหมาย (Assignment)" name="2">
          <div v-loading="loading"  class="pd-b-3">
            <ActivityTotalScoreListInstructor
              :dataList="subjectList"
              :courseId="course"
              shwoColumn="assignment"
              :showCheckAssignment="true"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
      <div v-if="totalData > 10" class="pd-y-3 disabled-on-print">
        <el-pagination
          @current-change="changePage"
          background
          layout="prev, pager, next"
          :total="totalData"
          :page-size="pageSize"
          :current-page="page"
        ></el-pagination>
      </div>
    </div>
    <div v-else class="text-center">
      <p class="color-gray pd-y-1">*** ไม่มีข้อมูลหลักสูตร ***</p>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ActivityTotalScoreListInstructor from "@/components/activity/ActivityTotalScoreListInstructor";
import ActivityNamelistScore from "@/components/activity/ActivityNamelistScore";
import { HTTP } from "@/service/axios.js";
import {CancelToken } from "axios";

import CertificateCard from "@/components/certificate/CertificateCard";

export default {
  components: {
    DashboardTemplate,
    ActivityTotalScoreListInstructor,
    ActivityNamelistScore,
    CertificateCard
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
    courseList() {
      let courses = []
      this.$store.state.courseList.map((item)=>{
        let filter = item.subject.filter(filter => filter.instructor == this.user.userId)
        if (filter.length > 0) {
          courses.push(item)
        }
      })
      return courses;
    }
  },
  data() {
    return {
      activeName: "1",
      course: "",
      loading: true,
      page: 1,
      pageSize: 10,
      totalData: 0,
      subjectList:[],
      courseId:'',
      source:''
    };
  },
  mounted() {
    this.fetchCourseList();
    this.fetchManagePoint();
  },
  methods: {
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
      this.course = this.courseList.length > 0 ? this.courseList[0]._id : "";
      this.courseId = this.course
    },
    fetchManagePoint() {
      let obj = {
        courseId: this.courseId,
      };

      if (this.source) {
          this.source.cancel()
      }

      this.source = CancelToken.source()
      const cancelToken = this.source.token

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`manage/point`, obj,{cancelToken})
        .then((res) => {
          if (res.data.success) {
            this.subjectList = res.data.obj
            this.totalData = res.data.obj.length
          } else {
            this.subjectList = [];
            this.totalData = 0
          }
        })
        .catch((e) => {
          // this.alertCatchError(e);
          console.log("fetchManagePoint error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectCourse() {
      this.loading = true;
      this.courseId = this.course
      this.fetchManagePoint();
    },
    getCourseLabel(course) {
      let filter = this.courseList.filter((filter) => filter._id == course);
      return filter.length > 0 ? filter[0].name : "";
    },
    changePage(page) {
      this.page = page;
    },
    changeTab() {
      this.page = 1;
    },
    printCertificate(nameTH,surnameTH,successDate) {
      this.nameTh = nameTH
      this.lastNameTh = surnameTH
      this.courseName = this.getCourseLabel(this.course);
      this.endDate = successDate;

      setTimeout(() => {
        window.print();
      }, 500);
    },
  },
};
</script>